import { OptionProps } from '@digital/ui';

const optionsMoedas: OptionProps[] = [
  { value: '0', text: 'Real' },
  { value: '1', text: 'US$ VENDA' },
  { value: '2', text: 'UFIR' },
  { value: '3', text: 'US$ COMPRA' },
  { value: '4', text: 'US$ PATRIM' },
  { value: '5', text: 'JPY-IENE JAP' },
  { value: '6', text: 'GBP-LIBRA ES' },
  { value: '7', text: 'DEM-MARCO AL' },
  { value: '8', text: 'FRF-FRANCO F' },
  { value: '9', text: 'CHF-FRANCO S' },
  { value: '10', text: 'ATS-XELIM AU' },
  { value: '11', text: 'EUR - EURO' },
  { value: '12', text: 'Dolar Canadá' },
  { value: '20', text: 'COROA SUECA' },
  { value: '21', text: 'Dolar Fiji' },
  { value: '22', text: 'Coroa norueg' },
  { value: '23', text: 'US$ AUD' },
];

export default optionsMoedas;
